import { runInAction, makeObservable, observable, action } from "mobx";
import { getFeaturedItems } from "../services/getLearningItemService";
import LoadingStatus from "../constants/loadingStatus";

class FeaturedItemStore {
  data = [];
  loadingStatus = LoadingStatus.notStart;

  constructor() {
    makeObservable(this, {
      data: observable,
      loadingStatus: observable,
      load: action
    });
  }

  load = async tag => {
    try {
      this.loadingStatus = LoadingStatus.notStart;
      const rlt = await getFeaturedItems(tag);
      runInAction(() => {
        this.data = rlt.data;
        this.loadingStatus = LoadingStatus.loaded;
      });
    } catch {
      this.loadingStatus = LoadingStatus.error;
      console.log("get featured item error");
    }
  };
}

const store = new FeaturedItemStore();
export default store;
export { FeaturedItemStore };
